module.exports = __webpack_public_path__ + "static/media/C_S01.5da891f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/C_S01.png
// module id = 127
// module chunks = 0